// for reference: packages/nextjs-fullstack-application/node_modules/@deck.gl/layers/src/scatterplot-layer
import { ScatterplotLayer } from "@deck.gl/layers"
import { CompositeLayer } from "@deck.gl/core"
import { get } from "nodash"
import { VideoMetadata } from "@nova/slice-video"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"

export default class VideoPointsLayer extends CompositeLayer {
    static layerName = "VideoPoints"
    static id = "VideoPoints"
    pickable = true
    state = {} as {
        data: VideoMetadata
    }
    updateState({ changeFlags }: { changeFlags: Record<string, unknown> }) {
        const data = get(this.props, "data", [])
        if (changeFlags.dataChanged) {
            this.setState({ data })
        }
    }

    renderLayers() {
        return [
            new ScatterplotLayer({
                id: "videopoints-" + this.props.id,
                data: this.state.data,
                filled: true,
                pickable: true,
                radiusMinPixels: 1,
                radiusMaxPixels: 1,
                extensions: [...getGlobalTerrainData().extensions],
                getPosition: (d) => {
                    const dimensions = getGlobalTerrainData().terrainState ? 3 : 2
                    return d.slice(0, dimensions)
                },
                getFillColor: () => [200, 20, 20, 0],
            }),
        ]
    }
}
